import * as THREE from "three";
import { mapConfig } from "./mapConfig";
import { MapRuntime } from "./runtime";

export type AnimationControls = {
  raycaster: THREE.Raycaster;
  pointer: THREE.Vector2;
};

export function startMapAnimation(
  runtime: MapRuntime,
  controls: AnimationControls
) {
  const { raycaster, pointer } = controls;
  const clock = new THREE.Clock();
  const tangent = new THREE.Vector3();
  const position = new THREE.Vector3();

  const animate = function () {
    if (runtime.disposed) {
      return;
    }

    // 避免切回页面时 delta 过大导致跳跃
    const delta = Math.min(clock.getDelta(), 0.05);
    runtime.modelMixers.forEach((item) => item.update(delta));

    runtime.ratio.value += 0.01;

    runtime.animationFrameId = requestAnimationFrame(animate);
    raycaster.setFromCamera(pointer, runtime.camera);
    runtime.renderer.render(runtime.scene, runtime.camera);
    runtime.labelRenderer.render(runtime.scene, runtime.camera);

    runtime.spotList.forEach((mesh: any) => {
      mesh._s += 0.01;
      mesh.scale.set(1 * mesh._s, 1 * mesh._s, 1 * mesh._s);
      if (mesh._s <= 2) {
        mesh.material.opacity = 2 - mesh._s;
      } else {
        mesh._s = 1;
      }
    });

    // 世界空间匀速：补偿父级 (mapScale, mapScale, 1) 非等比缩放
    const speed = mapConfig.flyArrowSpeed;
    runtime.flySpotList.forEach(function (mesh: any) {
      const length =
        mesh._curveLength || Math.max(mesh.curve.getLength(), 0.001);
      const mapScale = mesh._mapScale || 1;

      mesh.curve.getTangentAt(mesh._s, tangent).normalize();
      const worldFactor = Math.sqrt(
        (tangent.x * mapScale) ** 2 +
          (tangent.y * mapScale) ** 2 +
          tangent.z ** 2
      );

      mesh._s =
        (mesh._s + (speed * delta) / (length * Math.max(worldFactor, 0.001))) %
        1;

      mesh.curve.getPointAt(mesh._s, position);
      mesh.curve.getTangentAt(mesh._s, tangent).normalize();
      mesh.position.copy(position);
      if (mesh._tangentAxis) {
        mesh.quaternion.setFromUnitVectors(mesh._tangentAxis, tangent);
      }
    });
  };

  animate();
}
